import axiosHttp from "services/axiosHttp";
import { REWARD_BASE_URL } from "configs/AppConfig";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchCashierList = createAsyncThunk(
  "fetchCashierList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.get(
        `${REWARD_BASE_URL}pos-cashier`
      );
      return response.data.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const CashierListSlice = createSlice({
  name: "CashierListSlice",
  initialState: {
    isLoading: false,
    isError: false,
    error: null,
    data: null,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCashierList.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(fetchCashierList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.data = action.payload;
    });
    builder.addCase(fetchCashierList.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    });
  },
});

export default CashierListSlice.reducer;